import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { CreditCardBenefitMetadataExtension } from './extension/credit_card-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('credit_card').add(BenefitMetadataExtensionInterface, new CreditCardBenefitMetadataExtension()).build(),
);
